import { P as PubSub } from './pubsub-COBwjfLh.js';
import { N as Notyf } from './notyf-DIw0RvBj.js';

class QuantityInput extends HTMLElement {
  #abortController = new AbortController();
  #input;
  #buttons;
  #minusButton;
  #deleteButtonIcon;
  #minusButtonIcon;
  #trashIconShown = false;

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.#input = this.querySelector('input');
    this.#buttons = this.querySelectorAll('button');
    this.#minusButton = this.querySelector('[data-minus-button]');
    this.#deleteButtonIcon = this.querySelector('[data-delete-button-template]');
    this.#minusButtonIcon = this.querySelector('[data-minus-button-template]');
    this.#trashIconShown =
      this.dataset.showDeleteButton === 'true' && Number(this.#input.value) === 1;

    this.#buttons.forEach((button) => {
      button.addEventListener('click', (event) => this.#handleStep(event.currentTarget.name), {
        signal,
      });
    });

    this.#input.addEventListener(
      'input',
      () => {
        this.#input.value = this.#input.value.replace(/[^\d]/g, '');
      },
      { signal }
    );

    this.#input.addEventListener(
      'change',
      () => {
        this.#constrainAndUpdateInput(Number(this.#input.value));
        this.#updateButtons();
        this.#publishQuantityChange();
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  /**
   * Handle the step up or step down of the quantity
   * @param {string} type - The type of step to be taken
   */
  #handleStep(type) {
    const value = parseInt(this.#input.value);
    const step = parseInt(this.#input.step) || 1;
    const newValue = type === 'minus' ? Math.max(value - step, 0) : value + step;
    const updatedValue = this.#constrainAndUpdateInput(newValue);

    if (parseInt(updatedValue) !== parseInt(value)) this.#publishQuantityChange();
  }

  /**
   * Constrain and update the input.
   * @param {number} newValue - The new value.
   * @returns {number} The constrained value.
   */
  #constrainAndUpdateInput(value) {
    const min = Number(this.#input.min) || 0;
    const max = Number(this.#input.max) || Infinity;
    this.#input.value = value;

    if (max && value >= max) {
      Notyf.error(window.toast_translations.product.quantity.error_max.replace('{{ max }}', max));
      this.#input.value = max;
    } else if (min && value <= min) this.#input.value = min;

    return this.#input.value;
  }

  #updateButtons() {
    if (this.dataset.showDeleteButton !== 'true') return;

    const icon = this.#minusButton.querySelector('.icon');
    if (Number(this.#input.value) === 1 && !this.#trashIconShown) {
      icon.innerHTML = this.#deleteButtonIcon.innerHTML;
      this.#trashIconShown = true;
    } else if (Number(this.#input.value) > 1 && this.#trashIconShown) {
      icon.innerHTML = this.#minusButtonIcon.innerHTML;
      this.#trashIconShown = false;
    }
  }

  #publishQuantityChange() {
    PubSub.publish('quantity:change', {
      line: this.dataset?.itemIndex,
      quantity: this.#input.value,
    });
  }
}

customElements.define('quantity-input', QuantityInput);
